import { Component, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/shared/base/base-list.component';
import { Constants } from 'src/app/app.constants';
import { Dialog, DialogService } from '../../../../core/dialog.service';
import { Role } from '../roles.models';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { RequestService } from 'src/app/core/request.service';
import { UtilityService } from 'src/app/core/utility.service';
import { RouteAuthorities } from 'src/app/shared/base/base.models';
import { BaseService } from 'src/app/shared/base/base.service';

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.scss']
})
export class RolesListComponent extends BaseListComponent implements OnInit {
  public gridStateKey: string = 'roles_list_grid_state';
  public lookupColumns: Array<string> = ['value', 'description', 'parentValue', 'groups'];
  public roles: Role[];

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService
    ) { 
      super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
      this.authorities = new RouteAuthorities(authService, alertService, 'CUD_RL', 'R_RL', 'CUD_RL', 'CUD_RL');
      this.creatable = this.authorities.create;
      this.editable = this.authorities.update;
      this.deletable = this.authorities.delete;
      this.activatable = this.authorities.update;
    }

  ngOnInit(): void {
    this.authorities.init('CUD_RL', 'R_RL', 'CUD_RL', 'CUD_RL');
        
    this.url = `${Constants.contextPath}/roles`;

    // this.getGridData();

    this.baseService.getAll(`${this.url}/list`, (response: Role[]) => {
        this.roles = response;
    });
  }

  public delete(id: string): void {
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
        this.baseService.delete(this.url, id, () => {
            this.alertService.success('SHARED.DELETE_SUCCESS');
            this.baseService.getAll(`${this.url}/list`, (response: Role[]) => {
                this.roles = response;
            });
        }, (error) => {
            this.alertService.error(error, true);
        });
    });
    
    this.dialogService.show(dialog);
}

public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
}

public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
}
}